import React, { Component } from "react";
import { toast } from "react-toastify";
import { PiTrash } from "react-icons/pi";
import SearchSharpIcon from '@material-ui/icons/SearchSharp';
import { Modal, Form, Button, Table, OverlayTrigger, Tooltip, InputGroup, FormControl } from "react-bootstrap";
import { PiMagnifyingGlass, PiTargetThin } from "react-icons/pi";

import axios from "../../axios";
import apiError from "../../error";
import "./customgroup-modal.css";
import swal from "sweetalert";
import { debounce, getCookie } from "../../function";
import { PiCloudArrowDownLight } from "react-icons/pi";
import CSVModal from "../rightside-modal/upload-csv-modal";
import GetAppSharpIcon from '@material-ui/icons/GetAppSharp';
import Pagination from "react-js-pagination";
import Loader from '../../component/loader/loader'


export default class CustomGroupModal extends Component {

	constructor(props) {
		super(props);
		this.isTAconnected = getCookie('isTAconnected');
		this.isTASyncing = getCookie('isTASyncing');
		this.state = {
			loading: false,
			limit: 10,
			search: "",
			page: 1,
			count: 0,
			showCSV: false,
			errorFile: null
		};
	}

	loadTargets = async () => {
		this.setState({ loading: true });
		axios
			.get("/api/targets", {
				params: {
					limit: this.state.limit,
					search: this.state.search,
					groupId: this.props.selectedGroupId,
					page: this.state.page,
				},
			})
			.then(async (res) => {
				let selectedTargets = res.data.targets.map(targetKey => targetKey.target);
				this.props.setSelectedTargets(selectedTargets);
				this.setState({ loading: false, count: res.data.count });
			})
			.catch((error) => {
				this.setState({ loading: false });
				apiError(error);
			});
	};

	loadGroup = async () => {
		if (this.props.selectedGroupId > 0) {
			axios
				.get("/api/groups/" + this.props.selectedGroupId, {})
				.then((res) => {
					this.setState(
						{
							errorFile: res.data.errorFile,
						}
					);
				})
				.catch((error) => {
					apiError(error);
				});
		}
	};

  load = async () => {
    if (this.props.selectedGroupId) {
      this.loadTargets();
    }
  }
  debouncedLoad = debounce(async () => {
    if (this.props.selectedGroupId) {
      this.loadTargets();
    }
  }, 500)

	componentDidUpdate(prevProps) {
		if (((prevProps.show !== this.props.show) && this.props.show)) {
			if (!this.props.selectedGroupId) this.setState({ page: 1, count: 0, limit: 10, search: "", errorFile: null });
			this.load();
			if (this.props.groupType === "custom") this.loadGroup();
		}
		if (prevProps.searchshowmodal !== this.props.searchshowmodal && !this.props.searchshowmodal && this.props.selectedTargets.length === 0) {
			this.load();
		}
	}

	// Function to handle the removal of a target
	handleRemoveTarget = (targetId) => {
		if (this.props.selectedGroupId) {
			this.setState({ loading: true });
			axios.delete(`/api/targets/${targetId}/${this.props.selectedGroupId}`)
				.then(res => { this.loadTargets(); this.setState({ loading: false }); }).catch(err => { apiError(err); this.setState({ loading: false }); });
		} else {
			let updatedTargets = this.props.selectedTargets.filter(target => target.id !== targetId);
			this.props.setSelectedTargets(updatedTargets);
		}
	}

	handleAddUser = () => {
		if (!this.props.customGroupName) return toast.error("Please write the groupName first");
		this.props.searchOnClickHandler();
	}

	handleUploadCSV = () => {
		if (!this.props.customGroupName) return toast.error("Please write the groupName first");
		this.setState({ showCSV: true })
	}

  handleCreateGroup = () => {
    this.setState({loading: true})
    axios.post('/api/groups', {
      name: this.props.customGroupName,
    }, {})
      .then(res => {
        axios.post('/api/groups/assign-targets', { groupId: res.data.groupId, targets: this.props.selectedTargets })
          .then(res => {
            toast.success("Group created successfully");
            this.props.loadGroups();
            this.handleModalClose();
            if(this.isTAconnected) this.props.handleTabSelect("Custom");
            this.setState({loading: false})
          })
          .catch(error =>{ this.setState({loading: false}); apiError(error)});
      })
      .catch(err => {
        this.setState({loading: false})
        apiError(err);
      })
  }
  handleUpdateGroup = () => {
    this.setState({loading: true})
    axios.patch('/api/groups/'+this.props.selectedGroupId, {
      name: this.props.customGroupName,
    }, {})
      .then(res => {
        toast.success("Group Updated successfully");
        this.props.loadGroups();
        this.handleModalClose();
        this.setState({loading: false})
      })
      .catch(err => {
        this.setState({loading: false})
        apiError(err);
      })
  }
  handleModalClose = () => {
    this.setState({limit: 10, search: "", page: 1});
    this.props.handleModal(false);
    setTimeout(()=>{
      this.props.setCustomGroupName("");
      this.props.setSelectedTargets([]);
      this.props.setSelectedGroupId("");
      this.props.setSelectedTargets([]);
      this.props.setSelectedGroupType("custom");
    }, 200);
  }
  CSVHandle = () => {
    if (!this.props.customGroupName || this.props.customGroupName.length === 0 || this.props.customGroupName.trim().length === 0) {
        toast.error("Please Enter Group Name First");
    } else {
        this.setState({ showCSV: !this.state.showCSV });
        // this.props.handleModal(false);
    }
  };
  downloadErrorFile = () => {
    axios.get(`/api/groups/${this.props.selectedGroupId}/error-file`, {
        responseType: 'blob'
    })
        .then((res) => {
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement('a');
            link.href = url;
            const contentDisposition = res.headers['content-disposition'];
            const filename = contentDisposition ? `${this.props.customGroupName}-errorFile.csv` : 'errorFile.csv';
            link.setAttribute('download', filename);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        })
        .catch(err => {
            console.error('Error downloading the error file:', err);
        });
}

	render() {
		return (
			<>
				<Modal
					className="info-filter right mainfooterModal right-modal-wrap"
					show={this.props.show}
					onHide={this.handleModalClose}
					autoFocus
					keyboard
				>
					<Modal.Header closeButton>
						<div>
							<h5>{this.isTAconnected ? "Create Custom Group" : "Create Group"}</h5>
							<p>Select the users you want to add</p>
						</div>
					</Modal.Header>
					<Modal.Body>
						<div className="custominfoBox">
							<div style={{ width: "300px" }}>
								<Form.Label>Group Name</Form.Label>
								<Form.Group controlId="formBasicEmail">
									<Form.Control
										type="email"
										autoComplete="new-password"
										value={this.props.customGroupName.startsWith("ALL-Users-IN-COMPANY-") ? "all-users-tsat" : this.props.customGroupName}
										onChange={(e) => this.props.setCustomGroupName(e.target.value)}
										disabled={(this.props.customGroupName.startsWith("ALL-Users-IN-COMPANY-") || this.props.customGroupName === "Individual-Users" || this.props.groupType === "admin") || !this.props.permissibleActionsIAM['user-and-department-write']}
									/>
								</Form.Group>
								{!this.props.customGroupName.startsWith("ALL-Users-IN-COMPANY-") && this.props.customGroupName !== "Individual-Users" && this.props.groupType === "custom" && this.props.permissibleActionsIAM['user-and-department-write'] &&
									<div className="addUserbtn">
										<OverlayTrigger
											placement="top"
											overlay={
												this.isTASyncing ? (
													<Tooltip id="top"> <span>Threatcop Admin Sync is already in progress</span>
													</Tooltip>
												) : (
													<Tooltip id="top" className="d-none" />
												)
											}
										>
											<p className={`${this.isTASyncing && 'disabledCls3'}`}>
												Users List<sup className="red-star">*</sup>
												<span className="btn btn-primary addBtn ml-2" onClick={!this.isTASyncing ? this.handleAddUser : undefined}>
													<SearchSharpIcon className="searchIcon" />
													Select Users
												</span>
												{!this.isTAconnected && <span className="btn btn-primary addBtn ml-2" onClick={!this.isTASyncing ? this.handleUploadCSV : undefined}>
													<PiCloudArrowDownLight className="ti-cloud-down tiIcon" />
													Upload CSV
												</span>}
											</p>
										</OverlayTrigger>
									</div>
								}




              </div>
              {(this.props.selectedGroupId || this.props.selectedTargets?.length>0 ) &&
                <>
                  {this.props.selectedGroupId && <div className="filter-wrapper mb-2 p-0" style={{border: '1px solid #e2e5ed'}}>
                    <div className="alignItemsCenter row">
                      <div className="col-md-3 p-0">
                        <div className="positionSearchIcon">
                          <InputGroup className="search-wrap">
                            <FormControl
                              type="text"
                              placeholder="Search"
                              value={this.state.search}
                              onChange={(e)=> this.setState({search: e.target.value, page: 1}, () => this.debouncedLoad())}
                              
                              className="inputSearch mr-sm-2 form-control"
                            />
                            <PiMagnifyingGlass className="search-icon"></PiMagnifyingGlass>
                          </InputGroup>
                        </div>
                      </div>
                    </div>
                  </div>}
                  <div className="tableContainerWrapInner">
                    <Table responsive>
                      <thead className="bg-light">
                        <tr>
                          <th>Name</th>
                          <th>Designation</th>
                          {this.props.customGroupName && !this.props.customGroupName.startsWith("ALL-Users-IN-COMPANY-") && this.props.customGroupName!=="Individual-Users" && this.props.groupType==="custom" &&this.props.permissibleActionsIAM['user-and-department-delete'] &&
                            <th>Action</th>
                          }
                        </tr>
                      </thead>
                      <tbody>
                        {this.props.selectedTargets?.map(target => (
                          <tr key={(target.IdentityKey || target.id)}>
                            <td className="onlyForPinter">
                              <div className="flexTableData">
                                <div className="circle">
                                  <p className="circle-inner">{target.firstname[0]}</p>
                                </div>
                                <div>
                                  <h6>{target.firstname} {target.lastname}</h6>
                                  <span>{target.email}</span>
                                </div>
                              </div>
                            </td>
                            <td>{target.position || "---" || "_"}</td>
                            {this.props.customGroupName && !this.props.customGroupName.startsWith("ALL-Users-IN-COMPANY-") && this.props.customGroupName!=="Individual-Users" && this.props.groupType==="custom" &&this.props.permissibleActionsIAM['user-and-department-delete'] &&
                              <td>
                                
                                  <PiTrash
                                    className="trashIcon"
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => this.handleRemoveTarget((target.id))}
                                  />
                              </td>
                            }
                          </tr>
                        ))}
                        {!this.props.selectedTargets?.length && !this.state.loading &&
                          <p className="m-2">No data found</p>
                        }
                      </tbody>
                    </Table>
                  </div>
                </>
              }
            </div>
            {(this.props.selectedGroupId || this.props.selectedTargets?.length>0 ) && 
              <div className="pagination-Wrap p-0">
                <div className="row">
                  <div className="col-md-6">
                    {!this.state['loading'] ?
                      <Pagination
                        itemClass="page-item"
                        linkClass="page-link"
                        activePage={this.state.page}
                        itemsCountPerPage={this.state.limit}
                        totalItemsCount={this.state.count}
                        onChange={(pageNumber) => this.setState({ page: pageNumber }, () => this.load())}
                      /> : null
                    }
                  </div>
                  <div className="col-md-6 text-right d-flex align-items-center footer-pg">
                  <div className="w-100 pgCount">
                    {!this.props.selectedGroupId ? (
                      <p>Total users: {this.props.selectedTargets.length}</p>
                    ) : (
                      <p>
                        {this.state.count === 0
                          ? 0
                          : this.state.page * this.state.limit + 1 - this.state.limit}
                        -
                        {this.state.page * this.state.limit > this.state.count
                          ? this.state.count
                          : this.state.page * this.state.limit}{" "}
                        of {this.state.count} records
                      </p>
                    )}
                  </div>
                  </div>
                </div>
              </div>
            }
          </Modal.Body>
          <div className="modalFooter">
            <div className="row">
              <div className="col-md-12 text-right">
              

								<button onClick={this.handleModalClose} type="button" className="btn closeBtn">Cancel</button>

								{!this.props.customGroupName.startsWith("ALL-Users-IN-COMPANY-") && this.props.customGroupName !== "Individual-Users" && this.props.groupType === "custom" &&
									<OverlayTrigger
										placement="top"
										overlay={
											this.isTASyncing ? (
												<Tooltip id="top"> <span>Threatcop Admin Sync is already in progress</span>
												</Tooltip>
											) : (
												!this.props.permissibleActionsIAM['user-and-department-write']
													? (<Tooltip id="top">You don't have permission</Tooltip>)
													: (<Tooltip id="top" className="d-none"></Tooltip>)
											)
										}
									>
										<button
											disabled={!(this.props.selectedTargets?.length) || !this.props.permissibleActionsIAM['user-and-department-write']}
											type="button"
											className={`btn btn-success ml-2 btn btn-primary ${this.isTASyncing && 'disabledCls2'}`}
											onClick={this.props.permissibleActionsIAM['user-and-department-write'] && this.props.selectedGroupId ? !this.isTASyncing ? this.handleUpdateGroup : undefined : !this.isTASyncing ? this.handleCreateGroup : undefined}
										>
											{this.props.selectedGroupId ? "Update Group" : "Create Group"}
										</button>
									</OverlayTrigger>
								}
								{this.state.errorFile && this.props.customGroupName !== "Individual-Users" && <Button style={{ marginLeft: '8px' }} variant="warning" onClick={this.downloadErrorFile} rel="noopener noreferrer"><GetAppSharpIcon className="btn-icon"></GetAppSharpIcon> Error File </Button>}
							</div>
						</div>
					</div>

					<CSVModal
						show={this.state.showCSV}
						CSVHandle={this.CSVHandle}
						groupName={this.props.customGroupName}
						groupId={this.props.selectedGroupId}
						handleGroupModalClose={this.handleModalClose}
						handleGroupId={(groupId) => this.props.setSelectedGroupId(groupId)}></CSVModal>
				</Modal>
				{this.state.loading ? <Loader></Loader> : null}
			</>
		);
	}
}
